const shipment = {
  // 基本設定情報
  basicInfo: null,
  //   サービス (serviceDiv)
  //   サービス（表示用）(serviceName)
  //   荷主管理番号 (referenceNo)
  //   請求先情報 (billingInfo)
  //   出荷予定日 (shippingDate)
  //   貨物種別 (shipmentDiv)
  //   貨物種別（表示用）(shipmentDivName)
  //   伝票番号 (ytcNo)

  // お届け先情報
  consigneeInfo: null,
  //   区分 (consigneeDiv)
  //   区分（表示用）(consigneeDivName)
  //   名前 (consigneeName)
  //   国コード (consigneeCountryCd)
  //   国（表示用）(consigneeCountryName)
  //   エリアコード (consigneeCityCd)
  //   エリア（表示用）(consigneeCityName)
  //   TaxID区分 (consigneeUsciOcDiv)
  //   TaxID区分（表示用） (consigneeUsciDivName)
  //   TaxID番号 (consigneeUsciOcCd)
  //   電話番号 (consigneePhone)
  //   郵便番号 (consigneeZip)
  //   州 (stateCd)
  //   州（表示用） (consigneeAddress1)
  //   都市 (consigneeAddress2)
  //   住所 (consigneeAddress3)
  //   会社名・部署名 (consigneeAddress4)

  // ご依頼主情報
  shipperInfo: null,
  //   名前 (shipperName)
  //   法人番号・税関輸出入者コード (shipperOrganizationCd)
  //   電話番号 (shipperPhone)
  //   郵便番号 (shipperZip)
  //   都道府県 (shipperAddress1)
  //   市・区・郡 (shipperAddress2)
  //   町・番地・建物名 (shipperAddress3)
  //   会社名・部署名 (shipperAddress4)

  // 関税等諸費用の支払い方法
  paymentDiv: null,
  // 関税等諸費用の支払い方法（表示用）
  paymentDivName: null,
  // VAT種類
  vatRegisterDiv: null,
  // VAT種類（表示用）
  vatRegisterDivName: null,
  // VAT番号
  vatRegisterNumber: null,
  // インボイス発行
  invoiceOutDiv: null,
  // インボイス発行（表示用）
  invoiceOutDivLabel: null,
  // 運賃の支払い方法
  feePaymentDiv: null,
  // 運賃の支払い方法（表示用）
  feePaymentDivName: null,
  // クール区分
  coolDiv: null,
  // クール区分（表示用）
  coolDivName: null,
  // 荷物設定情報
  packageInfo: null,
  // Array object 荷物情報
  //  パッケージID (packageId)
  //   実重量 (grossWeight)
  //   正味重量 (netWeight)
  //   有償・無償 (paidDiv)
  //   有償・無償（表示用） (paidDivName)
  //   重量単位コード (weightUnitCd)
  //   重量単位コード（表示用） (weightUnitName)
  //   通貨 (currencyCd)
  //   建値 (shipmentTerm)
  //   縦幅 (length)
  //   横幅 (width)
  //   高さ (height)
  //   1番目備考 (note1)
  //   2番目備考 (note2)
  //   代表品目名 (representativeItemName)
  //   代表品目名（表示用） (representativeItemNameDisplay)
  //   品目情報 (itemInfo[])
  //   商品価格合計 itemTotal

  // お届け先マスタ登録フラグ
  registerConsigneeInfoFlg: null,
  // ご依頼主マスタ登録フラグ
  registerShipperInfoFlg: null,
  // 品目マスタ登録フラグ
  registerItemInfoFlg: null,
  overWriteConfirmFlag: null,
  errors: new Map()
};

const state = {
  // 送り状発行情報
  shipment: { ...shipment },
  editIssueList: null,
  printIssueList: null
};
const getters = {
  shipment: state => state.shipment,
  editIssueList: state => state.editIssueList,
  printIssueList: state => state.printIssueList
};

const mutations = {
  changeShipment(state, shipment) {
    // 送り状発行情報
    if (!shipment) {
      return;
    }
    const stateShipment = state.shipment;
    // 基本設定情報
    const basicInfo = shipment.basicInfo;
    if (basicInfo) {
      stateShipment.basicInfo = basicInfo;
    } else {
      stateShipment.basicInfo = null;
    }

    // お届け先情報
    const consigneeInfo = shipment.consigneeInfo;
    if (consigneeInfo) {
      stateShipment.consigneeInfo = consigneeInfo;
    } else {
      stateShipment.consigneeInfo = null;
    }

    // ご依頼主情報
    const shipperInfo = shipment.shipperInfo;
    if (shipperInfo) {
      stateShipment.shipperInfo = shipperInfo;
    } else {
      stateShipment.shipperInfo = null;
    }

    // 関税等諸費用の支払い方法
    stateShipment.paymentDiv = shipment.paymentDiv;
    // 関税等諸費用の支払い方法（表示用）
    stateShipment.paymentDivName = shipment.paymentDivName;
    // インボイス発行
    stateShipment.invoiceOutDiv = shipment.invoiceOutDiv;
    // インボイス発行（表示用）
    stateShipment.invoiceOutDivLabel = shipment.invoiceOutDivLabel;
    // 運賃の支払い方法
    stateShipment.feePaymentDiv = shipment.feePaymentDiv;
    // 運賃の支払い方法（表示用）
    stateShipment.feePaymentDivName = shipment.feePaymentDivName;
    // クール区分
    stateShipment.coolDiv = shipment.coolDiv;
    // クール区分（表示用）
    stateShipment.coolDivName = shipment.coolDivName;
    // VAT
    stateShipment.vatRegisterDiv = shipment.vatRegisterDiv;
    stateShipment.vatRegisterDivName = shipment.vatRegisterDivName;
    stateShipment.vatRegisterNumber = shipment.vatRegisterNumber;

    // 荷物設定情報
    const packageInfo = shipment.packageInfo;
    if (packageInfo) {
      stateShipment.packageInfo = packageInfo;
    } else {
      stateShipment.packageInfo = null;
    }

    // お届け先マスタ登録フラグ
    stateShipment.registerConsigneeInfoFlg = shipment.registerConsigneeInfoFlg;
    // ご依頼主マスタ登録フラグ
    stateShipment.registerShipperInfoFlg = shipment.registerShipperInfoFlg;
    // 品目マスタ登録フラグ
    stateShipment.registerItemInfoFlg = shipment.registerItemInfoFlg;
    stateShipment.overWriteConfirmFlag = shipment.overWriteConfirmFlag;
    stateShipment.errors = new Map();
  },
  addIssueList(state, editIssueList) {
    state.editIssueList = editIssueList;
  },
  addPrintIssueList(state, printIssueList) {
    state.printIssueList = printIssueList;
  },
  addErrorUps(state, errorUps) {
    state.shipment.errors = errorUps;
  },
  saveShipmentInfo(state, shipment) {
    if (!shipment) {
      return;
    }
    const shipmentState = state.shipment;
    if (!shipmentState.basicInfo) {
      shipmentState.basicInfo = {};
    }
    if (!shipmentState.consigneeInfo) {
      shipmentState.consigneeInfo = {};
    }

    // 荷主管理番号
    if (shipment.shipmentNo) {
      shipmentState.basicInfo.shipmentNo = shipment.shipmentNo;
    }

    // サービス
    if (shipment.serviceDiv) {
      shipmentState.basicInfo.serviceDiv = shipment.serviceDiv;
    }

    // 出荷予定日
    if (shipment.shippingDate) {
      shipmentState.basicInfo.shippingDate = shipment.shippingDate;
    }

    // 貨物種別
    if (shipment.shipmentDiv) {
      shipmentState.basicInfo.shipmentDiv = shipment.shipmentDiv;
    }

    // 国コード
    if (shipment.consigneeCountryCd) {
      shipmentState.consigneeInfo.consigneeCountryCd =
        shipment.consigneeCountryCd;
    }

    // エリアコード
    if (shipment.consigneeCityCd) {
      shipmentState.consigneeInfo.consigneeCityCd = shipment.consigneeCityCd;
    }

    // 実重量
    if (shipment.grossWeight) {
      shipmentState.packageInfo = [{ grossWeight: shipment.grossWeight }];
    }

    // 区分
    if (shipment.consigneeDiv) {
      shipmentState.consigneeInfo.consigneeDiv = shipment.consigneeDiv;
    }
  },
  clearShipment(state) {
    state.shipment = { ...shipment };
  }
};

export default {
  state,
  getters,
  mutations
};
